import type { CloseButtonProps } from 'react-toastify';

/** The close button of react-toastify 5 (a ✖︎ glyph), which version 11 replaced with an SVG. */
const ToastCloseButton = ({ closeToast, type, ariaLabel = 'close' }: CloseButtonProps) => (
  <button
    className={`Toastify__close-button Toastify__close-button--${type}`}
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      closeToast(e);
    }}
    aria-label={ariaLabel}
  >
    ✖︎
  </button>
);

export default ToastCloseButton;
